import { css } from 'styled-components';

/*
 * Prefer using `textStyles` for redesigned components.
 */
export const font = {
  family: css`
    font-family: CircularStd, 'SF Pro', 'Segoe UI', system-ui, sans-serif;
  `,
  regular: css`
    font-weight: 450;
  `,
  medium: css`
    font-weight: 500;
  `,
  bold: css`
    font-weight: 700;
  `,
  black: css`
    font-weight: 900;
  `,
  size: (size: number) => css`
    font-size: ${size}px;
  `,
};

export const textStyles = {
  bodyLarge450: css`
    font-weight: 450;
    font-size: 16px;
    line-height: 150%;
  `,
  bodyMedium450: css`
    font-weight: 450;
    font-size: 14px;
    line-height: 18px;
  `,
  bodySmall450: css`
    font-weight: 450;
    font-size: 13px;
    line-height: 16px;
  `,
  bodyCompact450: css`
    font-weight: 450;
    font-size: 12px;
    line-height: 15px;
  `,
  labelLarge450: css`
    font-weight: 450;
    font-size: 16px;
    line-height: 20px;
  `,
  labelLarge500: css`
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  `,
  labelMedium500: css`
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
  `,
  labelSmall500: css`
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
  `,
  labelCompact500: css`
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
  `,
  sectionTitle700: css`
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
    text-transform: uppercase;
  `,
  titleLarge700: css`
    font-weight: 700;
    font-size: 30px;
    line-height: 38px;
  `,
  titleMedium700: css`
    font-weight: 700;
    font-size: 24px;
    line-height: 150%;
  `,
  titleSmall500: css`
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
  `,
};
